// This browser's web push address once it is saved for the signed-in user (webPush.ts). Signing
// out sends it along (Auth.tsx), so the server stops pushing that user's notifications to a
// browser left signed out. A file of its own: the sign-in code needs nothing else of web push.
let saved: string | null = null

export const rememberPushEndpoint = (endpoint: string | null) => {
  saved = endpoint
}

/** Read synchronously: the sign-out does not wait for anything. */
export const pushEndpointForSignOut = () => saved
